module.exports = __webpack_public_path__ + "img/conta-azul.6ca2f740.svg";